import {
    FETCH_UPDATE_PROJECT_REQUEST,
    FETCH_UPDATE_PROJECT_SUCCESS,
    FETCH_UPDATE_PROJECT_FAILURE,
    SET_UPDATE_PROJECT
} from '../../actions/projects/update-projects-actions';

const initialState = {
    updatedProject: null,
    project: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateProjectReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_PROJECT_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_PROJECT:
            return {
                ...state,
                isLoading: false,
                error: null,
                project: { ...action.payload }
            };
        case FETCH_UPDATE_PROJECT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedSearcher: action.payload[0],
            };
        case FETCH_UPDATE_PROJECT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateProjectReducer;